module.exports = __webpack_public_path__ + "static/media/github-heart.4351edf4.svg";